module.exports = __webpack_public_path__ + "img/service-sem-1.2001f7fe.png";